module.exports = __webpack_public_path__ + "img/pro.ba4a0b18.png";